
<template>
  <div class="card-ads-horizontal-event noselect">
    <div class="photo-container-event">
      <NuxtLink :to="toRecipe">
        <div class="photo-event">
          <NuxtImg
            :src="$getImageSrc(img_small)"
            :alt="title"
            loading="lazy"
            fit="cover"
            width="60"
            height="60"
            class="img-ads-br img-fluid"
          />
        </div>
      </NuxtLink>
    </div>

    <div class="description-event ps-2">
      <div class="row-h-1-event">
        <div class="title-h-event">
          <NuxtLink :to="toRecipe">
            <h2>{{ title }}</h2>
          </NuxtLink>
        </div>
      </div>

      <NuxtLink :to="toRecipe">
        <div class="row-h-2-event">
          <div class="place-event">
            <p>
              <i class="esei icon-utensils-solid place-icon-color-ads font-size-11"></i>
              {{ category_name }}
            </p>
          </div>

          <div class="date-event" v-if="video_link">
            <h3 class="date-box font-size-14 fw-bold p-2 text-dark text-center">
              VIDEO
            </h3>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  id: { type: Number, required: true },
  title: { type: String, required: true },
  // nov recept ima slug; stari bez sluga - link iz naslova (stari nacin)
  slug: { type: String, default: null },
  img: { type: String, default: null },
  img_small: { type: String, required: true },
  category_name: { type: String, required: true },
  start_date: { type: String, default: null },
  video_link: { type: String, default: null },
})

const { $srbTolat } = useNuxtApp()

const toRecipe = computed(() => ({
  name: 'recept-category-title-id',
  params: {
    category: $srbTolat.srbTolatPathSlugify(props.category_name),
    title: props.slug || $srbTolat.srbTolatPathSlugify(props.title),
    id: props.id,
  },
}))

// (opciono) ako negde treba provera slike
const hasImg = computed(() => !!props.img_small && props.img_small.trim() !== '')
</script>

<style>
/* tvoji stilovi ostaju */
</style>
